/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
import { call, put, select } from 'redux-saga/effects';
import FrontSonda from '@gerenciatd/next.utils.front-sonda';
import {
  actions as mainActions,
  SONDA_KIND,
} from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n';
import { actions as publicActions } from '@/reducers/public';
import {
  normalizePublicModules,
  // onErrorGetProductsByAliasOrion,
} from './normalizers/public';

const filePath = 'sagas/public.js';

const contextStore = (state) => state.main.context;

/**
 * Obtiene todos la info de las paginas en abierto (Orion)
 * @returns {undefined}
 */
export function* getPublicInfo({ payload }) {
  const context = yield select(contextStore);
  const { alias, build } = payload;
  const frontSonda = new FrontSonda({
    processName: 'getPublicInfo',
    context,
    filePath: 'sagas/Public',
  });
  if (build || context?.eventType === 'loaded') {
    let response = '';
    try {
      try {
        const getProductByAliasOrionPromise = yield call(() =>
          import('@gerenciatd/next.adabyron.orion.get-product-by-alias-orion')
        );
        response = yield call(
          getProductByAliasOrionPromise.getProductByAliasOrion,
          {
            alias,
            context,
            build,
          }
        );
        // Si falla no obtenemos respuesta deseada mockeamos
        // if (!response || !response.data) {
        //   response = yield call(onErrorGetProductsByAliasOrion, {
        //     build,
        //     context,
        //     alias,
        //   });
        // }
      } catch (err) {
        frontSonda.errorMessage({
          err,
          info: 'Fallo del servicio: getProductsByAliasOrion',
        });
        // response = yield call(onErrorGetProductsByAliasOrion, {
        //   build,
        //   context,
        //   alias,
        // });
      }
    } catch (error) {
      yield put(
        mainActions.throwSonda({
          error,
          filePath,
          kind: SONDA_KIND.SEVERAL,
          processName: 'getPublicInfo',
        })
      );
      yield put(
        publicActions.setpublicInfo({
          status: 'ERROR',
          data: null,
        })
      );
    }
    const responseNormalized = normalizePublicModules(response, context);
    yield put(
      publicActions.setpublicInfo({
        status: build ? 'SUCCESS_BUILD' : 'SUCCESS',
        data: responseNormalized || null,
      })
    );
  } else {
    frontSonda.warningMessage({
      info: 'Entra Sin ser build ni tiene el contexto cargado',
    });
  }
}
